import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const API_URL = process.env.REACT_APP_API_URL;


export const fetchDistricts = createAsyncThunk(
  "districts/fetchDistricts",
  async (token, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/api/v1/districts`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const responseDataError = await response.json();
        return rejectWithValue(responseDataError.error || "Ошибка загрузки");
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const addDistrict = createAsyncThunk(
  "districts/addDistrict",
  async ({ sendData, token }, { rejectWithValue, dispatch }) => {
    try {
      const response = await fetch(`${API_URL}/api/v1/districts`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(sendData),
      });

      if (!response.ok) {
        const responseDataError = await response.json();
        toast.error("Ошибка добавления");
        return rejectWithValue(responseDataError.error || "Ошибка добавления");
      }

      await response.json();
      toast.success("Район успешно создан");
      dispatch(fetchDistricts(token));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const deleteDistrict = createAsyncThunk(
  "districts/deleteDistrict",
  async ({ id, token }, { rejectWithValue, dispatch }) => {
    try {
      const response = await fetch(`${API_URL}/api/v1/districts/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const responseDataError = await response.json();
        toast.error("Ошибка удаления");
        return rejectWithValue(responseDataError.error || "Ошибка удаления");
      }

      toast.success("Район успешно удален");
      dispatch(fetchDistricts(token));
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


const districtsSlice = createSlice({
  name: "districts",
  initialState: {
    districts: [],
    status: null,
    error: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(fetchDistricts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDistricts.fulfilled, (state, action) => {
        state.loading = false;
        state.districts = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchDistricts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
     
      .addCase(addDistrict.pending, (state) => {
        state.loading = true;
      })
      .addCase(addDistrict.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addDistrict.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
   
      .addCase(deleteDistrict.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteDistrict.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteDistrict.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default districtsSlice.reducer;
